export default "__VITE_ASSET__DNpPohhi__"